import { BehaviorSubject } from 'rxjs';
import {config} from '../config';
import { handleResponse, buildQuery, addTenant } from '../helpers';
import { authHeader } from '../helpers';


const CURRENT_USER_KEY = 'ciklopark_current_user';
const currentUserSubject = new BehaviorSubject(localStorage.getItem(CURRENT_USER_KEY));

export const authenticationService = {
    login,
    register,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { 
        if(currentUserSubject.value &&currentUserSubject.value.accessToken ){
            return currentUserSubject.value
    } 
    else{
        return JSON.parse(currentUserSubject.value)} },
    loginAnonymous,
    getUser,
    userUpdatePassword
};

function getUser() {
    return localStorage.getItem(CURRENT_USER_KEY) && JSON.parse(localStorage.getItem(CURRENT_USER_KEY)) || null;
}

function loginAnonymous() {
    const user = getUser();
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            "Authorization": user && `Bearer ${user?.accessToken}` || null
        },
    };

    return fetch(`${config.apiUrl}/token`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user));
            currentUserSubject.next(user);
            
            return user;
        });
}

async function login(credentials) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        //credentials: 'include',
        body: JSON.stringify(credentials)
        
    };
    return fetch(`${config.apiUrl}/login`, requestOptions)
    .then(handleResponse)
        .then(user => {
            if(user && user.name.length) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user));
                currentUserSubject.next(user);

                return user;
            }
            return null
        });
}

async function register(credentials) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        //credentials: 'include',
        body: JSON.stringify(credentials)
        
    };
    return fetch(`${config.apiUrl}/user`, requestOptions)
    .then(handleResponse)
        .then(() => {
            return login(credentials);
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem(CURRENT_USER_KEY);
    currentUserSubject.next(null);
}


async function userUpdatePassword(updateCredentials) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        //credentials: 'include',
        body: JSON.stringify(updateCredentials)
    };
    return fetch(`${config.apiUrl}/user/update-password`, requestOptions)
}